import {
    REQ_DATA_NOTIF,
    GET_DATA_NOTIF,
    REQ_DATA_NOTIF_LOCK,
    GET_DATA_NOTIF_LOCK,
    REQ_DATA_NOTIF_DOCS,
    GET_DATA_NOTIF_DOCS,
    CHANGE_STATUS_NOTIF
} from 'constants/ActionTypes';

export const reqDataNotif = () => {
    return {
        type: REQ_DATA_NOTIF
    }
}


export const getDataNotif = data => {
    return {
        type: GET_DATA_NOTIF,
        payload: data
    }
}

export const reqDataNotifLock = () => {
    return {
        type: REQ_DATA_NOTIF_LOCK
    }
}


export const getDataNotifLock = data => {
    return {
        type: GET_DATA_NOTIF_LOCK,
        payload: data
    }
}

export const reqDataNotifDocs = () => {
    return {
        type: REQ_DATA_NOTIF_DOCS
    }
}


export const getDataNotifDocs = data => {
    return {
        type: GET_DATA_NOTIF_DOCS,
        payload: data
    }
}

export const changeStatus = () => {
    return {
        type: CHANGE_STATUS_NOTIF,
        payload: true
    }
}




// WEBPACK FOOTER //
// ./actions/Notif.js